import React, { useMemo } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { transcriptTokenStyles } from "../../chat/chat-bubble/audio-transcription-markdown/styles";
import {
  getTranscriptHighlightPhase,
  tokenizeTranscriptWords,
  wordRangesByCharWeight,
} from "../../../utils/transcription";

interface AsyncRoleplayTranscriptTextProps {
  text: string;
  currentTimeSec?: number;
  durationSec?: number;
  isPlaying?: boolean;
}

export const AsyncRoleplayTranscriptText: React.FC<
  AsyncRoleplayTranscriptTextProps
> = ({
  text,
  currentTimeSec = 0,
  durationSec = 0,
  isPlaying = false,
}) => {
  const theme = useTheme();
  const tokens = useMemo(() => tokenizeTranscriptWords(text), [text]);

  const highlightActive =
    (isPlaying || currentTimeSec > 0.05) && durationSec > 0;

  if (!highlightActive || tokens.length === 0) {
    return (
      <Typography variant="body2" sx={{ mt: 0.25 }}>
        {text}
      </Typography>
    );
  }

  const ranges = wordRangesByCharWeight(tokens, 0, durationSec);

  return (
    <Typography variant="body2" sx={{ mt: 0.25, lineHeight: 1.55 }}>
      {tokens.map((token, i) => {
        const { start_sec, end_sec } = ranges[i];
        const phase = getTranscriptHighlightPhase(
          currentTimeSec,
          start_sec,
          end_sec,
        );
        return (
          <React.Fragment key={`tok-${i}-${token}`}>
            {i > 0 ? " " : null}
            <Box component="span" sx={transcriptTokenStyles(theme, phase)}>
              {token}
            </Box>
          </React.Fragment>
        );
      })}
    </Typography>
  );
};
